<div class="locationGridCell" *ngrxLet="viewModel$; let value;">
  @if (!value.loading) {
    <div id="businessHoursContainer"
      [ngClass]="{ 'text-neutral-60': value.isFieldBlacklisted }">
      @if (value.location?.mondayHours) {
        <div class="weekdayContainer">
          <span>Mon</span>
          @for (substring of (value.location?.mondayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
      @if (value.location?.tuesdayHours) {
        <div class="weekdayContainer">
          <span>Tue</span>
          @for (substring of (value.location?.tuesdayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
      @if (value.location?.wednesdayHours) {
        <div class="weekdayContainer">
          <span>Wed</span>
          @for (substring of (value.location?.wednesdayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
      @if (value.location?.thursdayHours) {
        <div class="weekdayContainer">
          <span>Thu</span>
          @for (substring of (value.location?.thursdayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
      @if (value.location?.fridayHours) {
        <div class="weekdayContainer">
          <span>Fri</span>
          @for (substring of (value.location?.fridayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
      @if (value.location?.saturdayHours) {
        <div class="weekdayContainer">
          <span>Sat</span>
          @for (substring of (value.location?.saturdayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
      @if (value.location?.sundayHours) {
        <div class="weekdayContainer">
          <span>Sun</span>
          @for (substring of (value.location?.sundayHours | split: ','); track substring) {
            <div class="weekdayHoursContainer">
              <span>{{substring}}</span>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (value.loading) {
    <ngx-skeleton-loader
      class="w-full"
    [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
  }
</div>

